import { splitPillMonikers } from '~/components/v2/components/workspace/workspace-agent-panel/utils/splitPillMonikers';

export const AUTOMATION_CUSTOM_PROMPT_PLACEHOLDER =
  'Say what Air should do on each run, and where. Type @ for boards, tags and fields, / for a skill.';

export type AutomationRunPromptMode = 'unset' | 'skillLinked' | 'custom';

export const buildSkillMonikerPrompt = (skillId: string): string => `@[skill:${skillId}]`;

/** Starter custom prompt when switching off an exclusive skill-linked run. */
export const buildCustomAutomationPromptFromSkillLink = (skillId: string): string =>
  `Use ${buildSkillMonikerPrompt(skillId)}`;

const isWhitespaceOnlyText = (value: string): boolean => value.trim() === '';

/** When prompt is exclusively one `@[skill:<id>]` (optional surrounding whitespace). */
export const parseExclusiveSkillMonikerPrompt = (prompt: string): string | null => {
  const trimmed = prompt.trim();

  if (trimmed === '') {
    return null;
  }

  const segments = splitPillMonikers(trimmed);
  let skillId: string | null = null;

  for (const segment of segments) {
    if (segment.type === 'text') {
      if (!isWhitespaceOnlyText(segment.value)) {
        return null;
      }
      continue;
    }

    if (segment.type !== 'pill' || segment.entityType !== 'skill') {
      return null;
    }

    if (skillId !== null) {
      return null;
    }

    skillId = segment.monikerId;
  }

  return skillId;
};

export const getAutomationRunPromptMode = (prompt: string): AutomationRunPromptMode => {
  if (prompt.trim() === '') {
    return 'unset';
  }

  return parseExclusiveSkillMonikerPrompt(prompt) !== null ? 'skillLinked' : 'custom';
};
